import { STATIC_CDN_IMAGES } from "@/config/constants";
import Image from "next/image";
import { MouseEventHandler } from "react";

const TapToUnmuteButton = (props: { playerMuted: boolean; unmuteVideo: MouseEventHandler<HTMLButtonElement> | undefined; }) => {
  if (!props.playerMuted) {
    return <></>
  }
  return (
    <button
      className="flex absolute z-[1] bg-slate-100 text-black font-medium h-6 top-0 left-0 px-2 text-xs items-center cursor-pointer whitespace-nowrap"
      onClick={props.unmuteVideo}>
      <Image className="mr-1"
        src={`${STATIC_CDN_IMAGES}/click-to-unmute-32-px.png`} alt="13" width={12} height={12} />
      TAP TO UNMUTE
    </button>
  );
}

export default TapToUnmuteButton;